import React, { FC } from 'react';

import { Player, UpdateStatus } from '../../../../../database.schema';
import { Button } from '../../../common-styles/common-styles';
import { useTournamentTeamGamesTeamsMutation } from '../../../../api/create-teams';

type UpdateButtonProps = {
  selectedTournamentIndex: number;
  team1: Array<Player>;
  team2: Array<Player>;
  nextMatchIndex: number;
  courseId: number;
  startingHole: number;
  matchFormat: string;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  onSuccess: () => void;
  disabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({
  nextMatchIndex,
  selectedTournamentIndex,
  team1,
  team2,
  courseId,
  startingHole,
  matchFormat,
  disabled,
  setUpdateStatus,
  onSuccess,
}) => {
  const mutation = useTournamentTeamGamesTeamsMutation();
  const saveTeams = () => {
    const dataToSave = { selectedTournamentIndex, team1, team2, nextMatchIndex, courseId, startingHole, matchFormat };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave, status: 'awaiting-scores' },
        {
          onSuccess: (data) => {
            onSuccess();
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        },
      );
    }
  };
  return (
    <Button data-testid="save-button" onClick={() => saveTeams()} disabled={disabled}>
      Save
    </Button>
  );
};
